export default "assets/images/logos_visa-6972f0ac.png";